<template>
    <div class="ak-about">
        <div class="crumb">
            <a href="/">首页</a> &gt; FAQ
        </div>
        <div class="content">
            <p>Q: AnyKnew是一个什么样的网站？</p>
            <p>A: 目前网站主要关注点是抓取各大网站的热门资讯排名，可以让用户花最短的时间了解最多最新的新闻内容。</p>
            <br>
            <p>Q: 内容源类别感觉还是有点少怎么办？</p>
            <p>A: 我们正在逐渐增加支持网站，接下来几周我们会逐渐增加大家反馈的比较多的类别比如金融、汽车等网站内容，其实增加网站相对不是很麻烦，比较麻烦的是筛选网站以及抓取网站的哪些栏目内容，这也是支持网站增加比较慢的一个原因。</p>
            <br>
            <p>Q: 能不能做到对热点新闻进一步聚合分类？</p>
            <p>A: 这是也是我们这两周准备新增的功能，本质上来说这是比较困难的<a href="https://baike.baidu.com/item/nlp/25220?fr=aladdin" target="_blank">NLP问题</a>，目前我们测试的方案在分类准确度上还是比较差没办法做到很细的分类粒度，这也是一般新闻站点都是人工分类的原因，不过我们会尽最大可能让信息浏览更高效(已经收到多个用户反馈说热点内容中娱乐明星比例太高，相信这个功能上线后会让这种情况好很多)。</p>
            <br>
            <p>Q: 为什么偶尔会发现首页显示的热点排行跟对应网站显示的有所不同？</p>
            <p>A: 这个绝大多数情况下是由于抓取延迟导致的，在实际应用我们没办法实时抓取某一网站的最新数据(一是太频繁的抓取会被对方网站判定为异常请求，二是我们资源有限不可能高并发的同时抓取多个网站，只能一个个更新遍历一遍站点也需要不少时间)，不过我们已经通过统计不同网站的更新频率为每个网站设定了不同的更新间隔，各类热榜数据更新延迟不会超过10分钟，这应该是可以接受的范围。</p>
            <br>
            <p>Q: 发现某个站点的数据长时间(比如一两个小时)没有更新？</p>
            <p>A: 这种情况下一般是由于对方网站改版，导致AnyKnew服务器运行的爬虫用老的解析模板没有办法解析新版页面。不过请您放心，这种情况下我们肯定已经在更新代码了，非睡眠时间最长修复间隔不会超过4小时:)</p>
            <br>
            <p>Q: 网站接下来功能有什么计划？</p>
            <p>A: 目前主要是想尽快把上面说的新闻聚合功能上线，还有一个依赖这个聚合功能的另一个反馈比较多的需求，接下来大的功能是增强国际新闻，我们构思很久了一个很有意思的看国际新闻的方式，相信到时会让您惊艳一下，上线时间争取在一月份内完成吧~</p>
            <br>
            <p>Q: 网站功能更新能不能再快点？</p>
            <p>A: 这个暂时比较抱歉，目前这个网站是几个人在业余时间做的小项目，前后端主要是我(写这些文字的人)自己在做，女朋友帮忙做UI优化，另外忽悠了一个大学舍友他在空闲时间帮忙做了个Android客户端，所以...你看，更新速度短时间没法提升😜</p>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
  export default {
    name: "faq",
    data() {
      return {
      }
    },
  }
</script>

<style lang="less">
    .ak-about{
        .crumb{
            margin: 20px auto;
            width: 1120px;
            /*height: 30px;*/
            border-radius: 5px;
            font-size: 1rem;
            /*background-color: #FFFFFF;*/

        }
        .content{
            /*align-items: center;*/
            justify-content: space-between;
            width: 1120px;
            /*min-height: 100%;*/
            margin: auto;
            padding: 10px;
            background-color: #FFFFFF;
            border-radius: 5px;
            font-size: 1rem;
            p{
                padding: 3px 0;
                a{
                    color: #3DB4F1;
                }
            }
            .android{
                width: 500px;
                min-height: 450px;
                border-radius: 5px;
                .title{
                    text-align: center;
                    font-size: 1.2rem;
                    padding: 10px 0;
                }
                .content{
                    text-align: center;
                    .app-img{
                        width: 200px;
                    }
                }
            }
            .ios{
                width: 500px;
                min-height: 450px;
                border-radius: 5px;
                background-color: #FFFFFF;
            }
        }
    }
</style>